import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "ai-countdown__item" }
const _hoisted_2 = { class: "ai-countdown__item__digits" }
const _hoisted_3 = {
  key: 0,
  class: "ai-countdown__item__digits__item"
}
const _hoisted_4 = { class: "ai-countdown__item__label" }
const _hoisted_5 = { class: "ai-countdown__item" }
const _hoisted_6 = { class: "ai-countdown__item__digits" }
const _hoisted_7 = {
  key: 0,
  class: "ai-countdown__item__digits__item"
}
const _hoisted_8 = { class: "ai-countdown__item__label" }
const _hoisted_9 = { class: "ai-countdown__item" }
const _hoisted_10 = { class: "ai-countdown__item__digits" }
const _hoisted_11 = {
  key: 0,
  class: "ai-countdown__item__digits__item"
}
const _hoisted_12 = { class: "ai-countdown__item__label" }

import { PropType } from 'vue';
import { storeToRefs } from 'pinia';

import { useCommonStore } from '@/store/common';

import VueCountdown from '@chenfengyuan/vue-countdown';


export default /*@__PURE__*/_defineComponent({
  __name: 'AiCountdown',
  props: {
  time: {
    type: Number as PropType<number>,
    required: true,
  },
},
  emits: ['end'],
  setup(__props, { emit: __emit }) {

const props = __props;

const { isMobile } = storeToRefs(useCommonStore());

const emits = __emit;

const endHandler = (): void => {
  emits('end');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ai-countdown", { 'ai-countdown--mobile': _unref(isMobile) }])
  }, [
    _createVNode(_unref(VueCountdown), {
      time: props.time,
      tag: "div",
      onEnd: endHandler
    }, {
      default: _withCtx(({ hours, minutes, seconds }) => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (String(hours).split('').length < 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, "0"))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(String(hours).split(''), (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "ai-countdown__item__digits__item"
              }, _toDisplayString(item), 1))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('countdown.hours')), 1)
        ]),
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "ai-countdown__divider" }, ":", -1)),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (String(minutes).split('').length < 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, "0"))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(String(minutes).split(''), (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "ai-countdown__item__digits__item"
              }, _toDisplayString(item), 1))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('countdown.minutes')), 1)
        ]),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "ai-countdown__divider" }, ":", -1)),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            (String(seconds).split('').length < 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, "0"))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(String(seconds).split(''), (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "ai-countdown__item__digits__item"
              }, _toDisplayString(item), 1))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('countdown.seconds')), 1)
        ])
      ]),
      _: 1
    }, 8, ["time"])
  ], 2))
}
}

})